import { postConfig } from "./post-config";
import { Message, postMessageToChild } from "./post-message";

if (!document.currentScript || !("src" in document.currentScript)) {
  throw new Error("Unknown script URL");
}

const currentScript = new URL(document.currentScript.src);

const iframes = new WeakMap<MessageEventSource, HTMLIFrameElement>();

window.addEventListener(
  "message",
  async function (e: MessageEvent<Message>) {
    if (e.source && e.data.kind === "oz-wizard-resize") {
      const iframe = iframes.get(e.source);
      if (iframe) {
        const height = Math.ceil(e.data.height).toString();
        iframe.style.height = height !== "0" ? `${height}px` : "100%";
      }
    }

    if (e.source && e.data.kind === "oz-wizard-style") {
      const iframe = iframes.get(e.source);
      if (iframe) {
        iframe.style.height = "100%";
      }
    }

    if (e.source && e.data.kind === "oz-wizard-export-contract-location") {
      const dom = e.source;
      if (dom) {
        const link = e.data.url;
        window.location.href = link;
      }
    }

    if (e.source && e.data.kind === "oz-wizard-clipboard-code-text") {
      const dom = e.source;
      if (dom) {
        const text = e.data.text;
        const opts = e.data.opts;
        const language = e.data.language;

        await navigator.clipboard.writeText(text);

        if (opts) {
          await postConfig(opts, "copy", language);
        }
      }
    }
  },
  false
);

function postParentStyle(styling: string, useChildStyle: boolean) {
  const iframe = document.querySelector("iframe");

  postMessageToChild(iframe, {
    kind: "oz-wizard-style",
    style: styling,
    useChildStyle,
  });
}

// post parent domain infos to child iframe
function postParentDomain(url: string) {
  const iframe = document.querySelector("iframe");

  postMessageToChild(iframe, {
    kind: "oz-wizard-export-contract-parent-domain",
    url: url,
  });
}

onDOMContentLoaded(function () {
  const wizards = document.querySelectorAll<HTMLElement>("oz-wizard");

  // load post function to child
  const windowAny: any = window;
  windowAny.wizard = {
    postParentStyle: postParentStyle,
    postParentDomain: postParentDomain,
  };

  for (const w of wizards) {
    w.style.display = "block";
    w.style.minHeight = "53rem";

    const src = new URL("embed", currentScript.origin);

    setSearchParam(w, src.searchParams, "data-lang", "lang");
    setSearchParam(w, src.searchParams, "data-tab", "tab");
    const sync = w.getAttribute("data-sync-url");

    if (sync === "fragment") {
      const fragment = window.location.hash.replace("#", "");
      if (fragment) {
        src.searchParams.set("tab", fragment);
      }
    }

    const iframe = document.createElement("iframe");
    iframe.src = src.toString();
    iframe.style.display = "block";
    iframe.style.border = "0";
    iframe.style.width = "100%";
    iframe.style.height = "53rem";
    iframe.allow = "*";
    // @ts-ignore
    iframe.sandbox =
      "allow-scripts allow-top-navigation allow-same-origin allow-top-navigation-by-user-activation allow-popups";

    w.appendChild(iframe);

    if (iframe.contentWindow !== null) {
      iframes.set(iframe.contentWindow, iframe);
    }

    if (sync === "fragment") {
      window.addEventListener("message", (e: MessageEvent<Message>) => {
        if (e.source && e.data.kind === "oz-wizard-tab-change") {
          if (iframe === iframes.get(e.source)) {
            window.location.hash = e.data.tab;
          }
        }
      });
    }
  }
});

function setSearchParam(
  w: HTMLElement,
  searchParams: URLSearchParams,
  dataParam: string,
  param: string
) {
  const value = w.getAttribute(dataParam) ?? w.getAttribute(param);
  if (value) {
    searchParams.set(param, value);
  }
}

function onDOMContentLoaded(callback: () => void) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", callback);
  } else {
    callback();
  }
}

export {};
